import { useState } from 'react';
import DataTable from '../../components/DataTable/DataTable';
import SearchComponent from '../../components/DataTable/SearchComponent';
import { useUser } from '../../hooks/useUser';
import { Column } from 'react-table';
import ActivationModal from '../../components/Modals/ActivationModal';

const UserBlockedTable = () => {
  const {
    handleSearchUsersBlocking,
    blockedUsers,
    paginatorBlockedUsers,
    updatePageSize,
    pageSize,
    handleBlockingUsers,
  } = useUser();

  // Estados para los modales
  const [isActivationModalOpen, setIsActivationModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<{ id: number; locked: boolean; username: string } | null>(null);

  // 📌 Función para manejar la activación/desbloqueo de usuario
  const handleToggleUserStatus = (user: { id: number; locked: boolean; username: string }) => {
    setSelectedUser(user);
    setIsActivationModalOpen(true);
  };

  // 📌 Confirmar activación/desbloqueo
  const handleConfirmToggleStatus = () => {
    if (selectedUser) {
      handleBlockingUsers({ id: selectedUser.id });
    }
    setIsActivationModalOpen(false);
  };

  // 📌 Cancelar activación/desbloqueo
  const handleCancelToggle = () => {
    setIsActivationModalOpen(false);
    setSelectedUser(null);
  };

  // 📌 Acciones de la tabla
  const actions = [{ key: 'toggle', onClick: handleToggleUserStatus }];

  // 📌 Columnas de la tabla
  const columns: Column<object>[] = [
    { Header: 'Nombre de usuario', accessor: 'username' },
    { Header: 'Correo electrónico', accessor: 'email' },
    {
      Header: 'Bloqueado',
      accessor: 'locked',
      Cell: ({ value }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value ? 'bg-red text-white' : 'bg-green-500 text-white'
          }`}
        >
          {value ? 'Bloqueado' : 'Activo'}
        </span>
      ),
    },
    { Header: 'Fecha de Bloqueo', accessor: 'lockedAt' },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        data={blockedUsers}
        actions={actions}
        pageSizeOptions={[5, 10, 20, 50]}
        url="user-management/blocked-users"
        paginator={paginatorBlockedUsers}
        searchComponent={<SearchComponent onSearch={handleSearchUsersBlocking} pageSize={pageSize} />}
        onPageSizeChange={updatePageSize}
        noDataMessage="No se encontraron usuarios bloqueados."
      />

      {/* Modal para activar/desbloquear usuario */}
      <ActivationModal
        isOpen={isActivationModalOpen}
        title={selectedUser?.locked ? '¿Desbloquear Cuenta?' : '¿Bloquear Cuenta?'}
        message={
          selectedUser?.locked
            ? '¿Estás seguro de que deseas desbloquear esta cuenta?'
            : '¿Estás seguro de que deseas bloquear esta cuenta?'
        }
        confirmText={selectedUser?.locked ? 'Desbloquear' : 'Bloquear'}
        cancelText="Cancelar"
        onConfirm={handleConfirmToggleStatus}
        onCancel={handleCancelToggle}
      />
    </>
  );
};

export default UserBlockedTable;
